export default "__VITE_ASSET__Bvz5Rzg$__"